export const hasNonLatinCharacters = (text: string): boolean => {
  // Only allow Latin characters (A-Z, a-z), numbers (0-9), and common punctuation/symbols
  // This includes: Basic Latin, Latin-1 Supplement, Latin Extended-A, Latin Extended-B
  const latinRegex = /^[\u0000-\u007F\u00A0-\u024F\u1E00-\u1EFF\s\d\p{P}\p{S}]*$/u;

  return !latinRegex.test(text);
};
